import { defineStore } from 'pinia';
import { useModuleStore } from '../moduleStore';
import AdminService from '@/services/admin.service';

export const useMailingSystemStore = defineStore('mailingSystem', {
    state: () => ({
        id_module: null,
        filtersContactListing: null,
        filteredInscriptionsList: null,
        campaign: null,
    }),
    actions: {
        initFiltersContactListingFromModule() {
            const moduleStore = useModuleStore();
            this.id_module = moduleStore.id;
            let courses = moduleStore.courses.list;
            let coursesFilter = [...courses.map(course => ({ name: course.nom, id: course.id, selected: false }))];
            let optionsFilter = [...moduleStore.options.list.map(option => ({ name: option.nom, id: option.id, selected: false }))];
            let filters = [
                { label: "Courses", name: "courses", value: 0, type: "select", options: coursesFilter },
                { label: "Options", name: "options", value: 0, type: "select", options: optionsFilter },
            ]
            this.filtersContactListing = filters;

        },

        async fetchFilteredInscriptionsList(filters) {

            let response = await AdminService.FetchMailingSystemFilteredInscriptionsList(filters, this.id_module);
            if (response) {
                this.filteredInscriptionsList = response.list;
            }
        },
        async createContactList(listName, contacts) {
            let response = await AdminService.CreateMailingSystemList(listName, contacts, this.id_module);
            return response;
        }
    }
});